import React, { useState } from 'react';
import { ChatsList } from '../components/chats/ChatsList';
import { LoadingScreen } from '../components/ui/LoadingScreen';
import { Chat } from '../types/chat';
import { chatAPI } from '../services/api';
import { useChatsContext } from '../context/ChatsContext';

interface ChatsListPageProps {
  onChatSelect: (chat: Chat) => void;
}

export const ChatsListPage: React.FC<ChatsListPageProps> = ({ onChatSelect }) => {
  const [showLoadingScreen, setShowLoadingScreen] = useState(false);
  const [loadingText, setLoadingText] = useState('Загрузка...');
  const { createChatByNumber, loadChats } = useChatsContext();

  const handleRandomSearch = async () => {
    try {
      setLoadingText('Поиск случайного собеседника...');
      setShowLoadingScreen(true);

      const response = await chatAPI.findRandomUser();
      createChatByNumber(response.data.userNumber);

      setTimeout(() => {
        setShowLoadingScreen(false);
        loadChats();
      }, 3000);
    } catch (error: any) {
      setShowLoadingScreen(false);
      alert(error.response?.data?.message || 'Ошибка поиска случайного пользователя');
    }
  };

  const handleSearchByNumber = async (numberToFind: string) => {
    if (numberToFind.trim()) {
      try {
        setLoadingText('Поиск пользователя...');
        setShowLoadingScreen(true);

        createChatByNumber(numberToFind.trim());

        setTimeout(() => {
          setShowLoadingScreen(false);
          loadChats();
        }, 5000);
      } catch (error: any) {
        setShowLoadingScreen(false);
        alert(error.response?.data?.message || 'Ошибка поиска пользователя');
      }
    }
  };

  return (
    <>
      <div className='h-screen'>
        <ChatsList
          onChatSelect={onChatSelect}
          onRandomSearch={handleRandomSearch}
          onSearchByNumber={handleSearchByNumber}
        />
      </div>

      <LoadingScreen
        isVisible={showLoadingScreen}
        onComplete={() => setShowLoadingScreen(false)}
        loadingText={loadingText}
        minDuration={5000}
      />
    </>
  );
};
